import { createEvent, Event } from 'effector'

import store from './store'

export const render: Event<React.ReactElement> = createEvent('render')
export const reset = createEvent('reset')

store.on(render, (_, payload) => payload).reset(reset)
